module.exports = __webpack_public_path__ + "static/media/down_nobrand.423e31f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/down_nobrand.mp4
// module id = GSOM
// module chunks = 0